import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { fmtDate } from "@/lib/format";
import { AlertOctagon } from "lucide-react";

export default function ExpiryWatchdog() {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/reports/expiry-watchdog?days=${days}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [days]);
  if (!d) return <div className="text-sm text-muted-foreground p-4">Loading…</div>;
  const tone = { expired: "bg-red-700/20 text-red-900 border-red-700", critical: "bg-red-500/15 text-red-800 border-red-500/40", warning: "bg-amber-500/15 text-amber-800 border-amber-500/40", watch: "bg-slate-500/10 text-slate-700 border-slate-400" };
  const bs = d.by_severity || {};
  return (
    <div className="space-y-4" data-testid="expiry-watchdog">
      <div className="flex items-end justify-between">
        <div className="text-[10px] font-mono uppercase text-muted-foreground">// Batch expiry watchdog</div>
        <div><Label className="text-[10px]">Window (days)</Label><Input type="number" value={days} onChange={(e) => setDays(Number(e.target.value))} className="rounded-sm h-8 w-24 tabular-nums" data-testid="ew-days" /></div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[{k:"expired"},{k:"critical"},{k:"warning"},{k:"watch"}].map((s) => (
          <Card key={s.k} className={`rounded-sm border p-3 ${tone[s.k]}`}>
            <div className="text-[10px] font-mono uppercase">{s.k}</div>
            <div className="text-2xl font-bold tabular-nums mt-1">{bs[s.k] || 0}</div>
          </Card>
        ))}
      </div>
      <div className="card-sharp overflow-hidden">
        <table className="w-full dense">
          <thead><tr><th>Severity</th><th>Item</th><th>SKU</th><th>Batch</th><th>Exp Date</th><th className="text-right">Days Left</th><th className="text-right">Qty Inward</th><th>Source</th></tr></thead>
          <tbody>
            {(d.rows || []).length === 0 && <tr><td colSpan="8" className="text-center py-10 text-muted-foreground">No batches expiring in the window.</td></tr>}
            {(d.rows || []).map((r) => (
              <tr key={r.movement_id} className={r.severity === "expired" ? "bg-red-500/5" : ""}>
                <td className={`text-[10px] font-mono uppercase ${r.severity === "expired" ? "text-red-800" : r.severity === "critical" ? "text-red-700" : r.severity === "warning" ? "text-amber-700" : "text-slate-600"}`}>
                  <AlertOctagon className="w-3 h-3 inline mr-1" />{r.severity}
                </td>
                <td>{r.name}</td>
                <td className="font-mono text-xs">{r.sku}</td>
                <td className="font-mono text-xs">{r.batch_no || "—"}</td>
                <td className="text-xs">{fmtDate(r.exp_date)}</td>
                <td className={`text-right tabular-nums font-medium ${r.days_left < 0 ? "text-red-800" : r.days_left <= 7 ? "text-red-700" : "text-amber-700"}`}>{r.days_left}</td>
                <td className="text-right tabular-nums">{r.qty_inward}</td>
                <td className="text-xs text-muted-foreground">{r.source_ref}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
